export function footerFixed() {
    let $footer = $(".footer");
    let $window = $(window);

    function setWrapperMargin() {

        if ($footer.hasClass("fixed")) {
            let $wrapper = $(".wrapper");
            let margin = $footer.outerHeight();

            if ($window.height() > 500) {
                $wrapper.css({
                    marginBottom: margin,
                });
            } else {
                $wrapper.css({
                    marginBottom: "",
                });
            }
        }
    }

    $window.on("load scroll", function () {
        setWrapperMargin();
    });
    
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer.js